













































































import { Component, Vue } from 'vue-property-decorator';
import Withdrawal from './components/Withdrawal.vue';
import Recharge from './components/Recharge.vue';
import WalletInfo from './components/WalletInfo.vue';
import WalletHistories from './components/WalletHistories.vue';
import RechargeHistories from './components/RechargeHistories.vue';
import WithdrawalHistories from './components/WithdrawalHistories.vue';

@Component({
    components: {
        'with-drawal': Withdrawal,
        're-charge': Recharge,
        'wallet-info': WalletInfo,
        'wallet-histories': WalletHistories,
        'recharge-histories': RechargeHistories,
        'withdrawal-histories': WithdrawalHistories
    }
})
export default class Credit extends Vue {
    private tabs = {
        reCharge: 'reCharge',
        withDrawal: 'withDrawal',
        rechargeRequests: 'rechargeRequests',
        ledger: 'ledger'
    };

    private selectedTab = this.tabs.reCharge;

    private onSelectTab(tab: string) {
        this.selectedTab = tab;
    }
}
